import { ISalesCounterpart } from 'models/ISalesCounterpart';

export function toSalesCounterpart(value?: unknown): ISalesCounterpart | undefined {
  if (!value || typeof value !== 'string') {
    return undefined;
  }

  const trimmedValue = value.trim();
  const match = trimmedValue.match(/^(.+?)\s+\(([^)]+)\)$/);

  if (!match) {
    return undefined;
  }

  const [, label, id] = match;

  return {
    id: id.trim(),
    label: label.trim(),
  } as ISalesCounterpart;
}
